import React from 'react';

export function UpdateConfigSteps({ step, type }: { step: number; type: 'product' | 'merchant' }) {
  return (
    <div className="ui mini steps">
      <div className={`step ${step == 1 && 'active'}`}>
        <div className="content">
          <div className="description">Affected {type === 'product' ? 'Products' : 'Merchants'}</div>
        </div>
      </div>
      <div className={`step ${step == 2 && 'active'}`}>
        <div className="content">
          <div className="description">Update Config</div>
        </div>
      </div>
      <div className={`step ${step == 3 && 'active'}`}>
        <div className="content">
          <div className="description">Preview Changes</div>
        </div>
      </div>
    </div>
  );
}
